// extracted by mini-css-extract-plugin
export default {"container":"loadingScreen_container__-qTLZ","loader":"loadingScreen_loader__O8pRz","spanloader":"loadingScreen_spanloader__k6WMD","bounce2":"loadingScreen_bounce2__W-e1-"};